import React, { useMemo } from 'react';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { User } from 'data/members/api';
import { CpWidgetProps } from '../../types/widget';
import { CpTeamMemberCard } from './variants/cp-team-members-card';
import { CpTeamMemberList } from './variants/cp-team-members-list';

interface CpTeamMemberWidgetData extends Record<string, unknown> {
  title: string;
  description: string;
  teamMemberFields: Array<string>;
  teamMembers: Array<User>;
}

export type CpTeamMemberWidgetProps = Omit<CpWidgetProps, 'data'> & {
  data: CpTeamMemberWidgetData;
};

export const CpTeamMemberWidget: React.FC<CpWidgetProps> = ({
  disabled,
  data,
  widget,
  projectId,
}) => {
  const widgetData = useMemo(() => data as CpTeamMemberWidgetData, [data]);

  switch (widget?.widgetVariantType) {
    case CpWidgetVariantType.TeamMemberList:
    case undefined:
      return (
        <CpTeamMemberList
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
        />
      );
    case CpWidgetVariantType.TeamMemberCard:
      return (
        <CpTeamMemberCard
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
        />
      );
    default:
      return <></>;
  }
};
